import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/auth/verify-email`,
          {
            params: { token, email },
            withCredentials: true,
          }
        );

        setStatus('success');
        setMessage(response.data.message);

        // Optional: Redirect after a few seconds
        // setTimeout(() => navigate('/login'), 4000);
      } catch (err) {
        setStatus('error');
        if (err.response && err.response.data && err.response.data.message) {
          setMessage(`${err.response.data.message} Your link may be invalid or may have expired. Please try submitting a new email verification, if applicable.`);
        } else {
          setMessage('An unexpected error occurred.');
        }
      }
    };

    if (token && email) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage('Invalid verification link. Your link may be invalid or may have expired. Please try submitting a new email verification, if applicable.');
    }
  }, [token, email, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center', marginBottom:"50vh" }}>
      <h1 className="subtitle-centered">Email Verification</h1>
      {status === 'loading' && <p className="subtitle-centered">Verifying your email...</p>}
      {status !== 'loading' && (
        <p className="subtitle-centered" style={{ color: status === 'success' ? 'green' : 'red', marginTop:"2rem", display:"flex", flexDirection:"column", alignItems:"center" }}>{message}{status === 'success' && <Link to="/log-in" style={{marginTop:"3rem", width:"fit-content"}} className="verify-email-redirect">Log In</Link>}</p>
      )}
      
    </div>
  );
};

export default VerifyEmail;
